import type { ReactNode } from "react";
import { useRef } from "react";
import { uniqueId } from "lodash";
import { useFormContext } from "react-hook-form";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { useUsageContext } from "@circle-react/providers";

interface RadioInputProps {
  children?: ReactNode;
  label: string;
  value: string;
  valueOmitted?: boolean;
}

export function RadioInput({
  label,
  value,
  children,
  valueOmitted = false,
}: RadioInputProps) {
  const inputIdRef = useRef(uniqueId());
  const { current: inputId } = inputIdRef;

  const { section } = useUsageContext();
  const isSectionAdmin = section === "admin";

  const comparatorRadioName = "filter_type";
  const { watch, register } = useFormContext();
  const comparatorSelectedValue = watch(comparatorRadioName);

  return (
    <div className="flex px-4 py-3">
      <div className="grid w-full grid-cols-[min-content,_1fr] grid-rows-[min-content,_1fr] gap-x-4">
        <input
          type="radio"
          value={value}
          id={inputId}
          className={classNames(
            "peer row-span-2 mt-1",
            isSectionAdmin ? "text-default" : "text-darkest",
          )}
          {...register(comparatorRadioName)}
        />
        <label htmlFor={inputId} className="mb-0 text-base font-normal">
          {label}
        </label>
        {!valueOmitted && comparatorSelectedValue === value && (
          <div className="mt-3 w-full">{children}</div>
        )}
      </div>
    </div>
  );
}
